import useSkipModules from '~/composables/useSkipModules';

/*
 * Universal half of the OneTrust integration: it only injects the CMP script.
 * Kept universal so the tag is server rendered and OneTrust starts downloading
 * during HTML parse. All browser wiring lives in `01.one-trust.client.ts`.
 * The split is by responsibility, not by order — neither half depends on the
 * other's position in the plugin sequence.
 */
export default defineNuxtPlugin((nuxt) => {
  const { skipModule, moduleNames } = useSkipModules(nuxt._route);
  if (skipModule(moduleNames.ONETRUST)) { return; }

  const rtConfPub = useRuntimeConfig().public;
  if (!rtConfPub?.oneTrustCookie?.domain) { return; }

  useHead({
    script: [
      {
        id: 'onetrust',
        src: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
        'data-domain-script': `${rtConfPub.oneTrustCookie?.domain}`
      }
    ],
    style: [
      {
        innerHTML: '.ot-floating-button, .ot-sdk-custom-button {display: none !important;}'
      }
    ]
  });
});
